import { components } from 'react-select';

const ReactSelectGroupHeading = components.GroupHeading;

/**
 * @typedef {import('react-select').GroupHeadingProps} GroupHeadingProps
 */

/**
 * @param {GroupHeadingProps} props
 * @returns {JSX.Element}
 */
export const GroupHeading = (props) => {
  return (
    <ReactSelectGroupHeading {...props} className={props.data?.groupHeaderClassName}>
      {props.children}
    </ReactSelectGroupHeading>
  );
};
